/**
 * Client version check against server's minClientVersion.
 * If client is outdated, force a page reload.
 */

const CLIENT_VERSION = '0.1.0';

/**
 * Compare semver strings (simple: major.minor.patch)
 * @param {string} a
 * @param {string} b
 * @returns {number} -1 if a < b, 0 if equal, 1 if a > b
 */
function compareSemver(a, b) {
  const pa = a.split('.').map(Number);
  const pb = b.split('.').map(Number);
  for (let i = 0; i < 3; i++) {
    if ((pa[i] || 0) < (pb[i] || 0)) return -1;
    if ((pa[i] || 0) > (pb[i] || 0)) return 1;
  }
  return 0;
}

/**
 * Check if the client version meets the server's minimum requirement.
 * If not, force reload to get new assets.
 */
export async function checkClientVersion() {
  try {
    const res = await fetch('/api/health');
    if (!res.ok) return;

    const data = await res.json();
    const minVersion = data.minClientVersion;
    if (!minVersion) return;

    if (compareSemver(CLIENT_VERSION, minVersion) < 0) {
      console.warn(`[Version] Client ${CLIENT_VERSION} < min ${minVersion}, rechargement...`);
      window.location.reload();
    }
  } catch (_err) {
    // Offline or server down — skip check
  }
}

export { CLIENT_VERSION };
